import React from "react";
import { CustomIcon } from "./CustomIcon";

// =============================================================
// AuthorityAssignmentField — multi-select Pastors / Team Members
// authorised to edit a Service or Event. Editable only by SA / LA.
// Non-admins see a read-only list of authorised names.
// =============================================================
export default function AuthorityAssignmentField({ value, onChange, users, canEdit, testIdPrefix = "authority" }) {
  const eligible = (users || []).filter(u => u && (u.role === "pastor" || u.role === "team_member"));
  const selected = Array.isArray(value) ? value : [];
  const selectedNames = selected
    .map(id => (eligible.find(u => u.id === id) || (users || []).find(u => u && u.id === id))?.name || id)
    .filter(Boolean);

  if (!canEdit) {
    return (
      <div className="form-group mb-14" data-testid={`${testIdPrefix}-readonly`}>
        <label>Edit Authority</label>
        <div style={{ fontSize: 12, color: "var(--kc-sub)", padding: "8px 10px", background: "color-mix(in srgb, var(--kc-accent) 6%, transparent)", border: "1px solid color-mix(in srgb, var(--kc-accent) 20%, transparent)", borderRadius: 6 }}>
          {selectedNames.length === 0
            ? "Admin only — no other users have edit authority."
            : selectedNames.join(", ")}
        </div>
      </div>
    );
  }

  const toggle = (id) => {
    const next = selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id];
    onChange(next);
  };

  return (
    <div className="form-group mb-14" data-testid={`${testIdPrefix}-field`}>
      <label>Edit Authority <span style={{ fontSize: 10, color: "var(--kc-meta)", fontWeight: 400 }}>(Pastors / Team Members who can edit this record)</span></label>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: "8px 6px", background: "rgba(255,255,255,0.03)", border: "1px solid color-mix(in srgb, var(--kc-accent) 25%, transparent)", borderRadius: 6, maxHeight: 160, overflowY: "auto" }}>
        {eligible.length === 0 && (
          <div style={{ fontSize: 12, color: "var(--kc-sub)", padding: "4px 8px" }}>No Pastors or Team Members available.</div>
        )}
        {eligible.map(u => {
          const on = selected.includes(u.id);
          return (
            <button
              key={u.id}
              type="button"
              data-testid={`${testIdPrefix}-toggle-${u.id}`}
              onClick={() => toggle(u.id)}
              style={{
                padding: "4px 10px", borderRadius: 999, fontSize: 11,
                fontFamily: "'Montserrat',sans-serif", fontWeight: 600,
                letterSpacing: "0.04em", cursor: "pointer",
                background: on ? "var(--kc-accent)" : "transparent",
                color: on ? "#1A1A1A" : "var(--kc-accent)",
                border: on ? "1.5px solid var(--kc-accent)" : "1.5px solid color-mix(in srgb, var(--kc-accent) 45%, transparent)",
                display: "inline-flex", alignItems: "center", gap: 4,
              }}
            >
              {on && <CustomIcon name="check" size={11} />}{u.name || u.username}
              <span style={{ marginLeft: 6, fontSize: 9, opacity: 0.7, textTransform: "uppercase" }}>{u.role === "pastor" ? "Pastor" : "Team"}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
